<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">診断条マスタ編集</h1>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <caption>診断条マスタ</caption>
          <tr>
            <th class="v-middle"><span>条名称</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextBox v-model="$v.diagSection.$model.sectionNm" @input="$v.diagSection.$touch()" />
                <ValidationErrorMessage v-show="$v.diagSection.sectionNm.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>条番号（並び順）</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                {{ diagSection.sortOrder ? diagSection.sortOrder : '最後尾に追加されます' }}
              </div>
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne mt-20 is-primary js-savebtn" @click="register()" :disabled="isProcessing"><a>更新</a></div>
        </div>
      </div>
      <div class="l-contentsBox" v-if="sectionId">
        <div style="display: flex; justify-content: flex-end;">
          <div class="btn-basic is-inlne is-primary">
            <button v-if="!canDrag" @click="canDrag = true">並び順を変更する</button>
            <button v-if="canDrag" @click="fixSortOrder()">並び順を確定する</button>
          </div>
        </div>
        <table class="l-form-table">
          <caption>診断項マスタ</caption>
          <tr>
            <td colspan="3">
              <button v-if="!canDrag" class="link-arrow" @click="goSubSectionNew()">新規追加</button>
            </td>
          </tr>
          <tr v-for="(diagSubSection, index) in diagSection.diagSubSections"
              :key="diagSubSection.subSectionId"
              :draggable="canDrag"
              @dragstart="dragIndex = index"
              @dragenter="changeSubSectionOrder(index)">
            <td class="v-middle" colspan="3">
              <button v-if="!canDrag" class="link-arrow" @click="goSubSectionEdit(diagSubSection.subSectionId)">編集</button>
              <span v-if="!canDrag">{{ diagSubSection.sortOrder }}</span>
              <span v-if="canDrag">三</span>
              <span v-if="canDrag">{{ index + 1 }}</span>
              <span @click="diagSubSection.isShow = !diagSubSection.isShow" :style="canDrag ? 'pointer-events: none;' : ''">
                {{ diagSubSection.subSectionNm }}
              </span>
              <transition name="slide" v-if="diagSubSection.isShow">
                <table class="l-form-table inner-table">
                  <tr v-for="diagItem in diagSubSection.diagItems" :key="diagItem.itemId">
                    <td class="v-middle">
                      <button class="link-arrow" @click="goItemEdit(diagItem.itemId)">編集</button>
                      {{ diagItem.checkItem }}
                    </td>
                  </tr>
                </table>
              </transition>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import { required } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';

export default {
  components: {
    Loading,
    TextBox,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      isAllPermission: false,
      diagSection: {
        sectionNm: '',
        sortOrder: null,
        diagSubSections: [
          {
            subSectionId: null,
            subSectionNm: '',
            diagItems: [
              {
                itemId: null,
                checkItem: ''
              }
            ],
            isShow: false,
          }
        ]
      },
      canDrag: false,
      dragIndex: null,
    }
  },
  validations: {
    diagSection: {
      sectionNm: { required },
    }
  },
  computed: {
    sectionId() {
      return this.$store.getters['master/getSectionId'];
    },
    verId() {
      return this.$store.getters['master/getVerId'];
    }
  },
  created: async function () {
    this.isProcessing = true;

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAllPermission = authority.isAllPermission;
    await this.getDiagSection(this.sectionId);

    this.$nextTick(() => {
      this.isProcessing = false;
    });
  },
  methods: {
    async getDiagSection(sectionId) {
      let res = await this.$axios.post('/ld/api/master/diag/getDiagSectionEdit', {
        sectionId: sectionId,
        verId: this.verId,
      });
      if (res) {
        this.diagSection = res.data.diagSection;
      }
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/diag/storeDiagSection', {
          diagSection: this.diagSection,
          verId: this.verId,
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          if (this.$route.name === 'diag-section-master-new') {
            this.$store.dispatch('master/setSectionId', res.data.diagSection.sectionId);
            this.$router.push({ name: 'diag-section-master-edit' });
          }
          await this.getDiagSection(res.data.diagSection.sectionId);
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    goSubSectionEdit(subSectionId) {
      this.$store.dispatch('master/setSubSectionId', subSectionId);
      this.$router.push({ name: 'diag-sub-section-master-edit' });
    },
    goSubSectionNew() {
      this.$store.dispatch('master/setSubSectionId', null);
      this.$router.push({ name: 'diag-sub-section-master-new' });
    },
    goItemEdit(itemId) {
      this.$store.dispatch('master/setItemId', itemId);
      this.$router.push({ name: 'diag-item-master-edit' });
    },
    changeSubSectionOrder(index) {
      if (index === this.dragIndex) return;
      const deleteElement = this.diagSection.diagSubSections.splice(this.dragIndex, 1)[0];
      this.diagSection.diagSubSections.splice(index, 0, deleteElement);
      this.dragIndex = index;
    },
    async fixSortOrder() {
      this.canDrag = false;

      this.diagSection.diagSubSections = this.diagSection.diagSubSections.map((dss, index) => {
        dss.sortOrder = index + 1;
        return dss;
      });

      this.isProcessing = true;
      const res = await this.$axios.post('/ld/api/master/diag/storeDiagSubSectionSortOrder', {
        diagSubSections: this.diagSection.diagSubSections,
        verId: this.verId,
      });
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
  }
}

</script>

<style scoped>
span {
  margin: 10px;
}

.inner-table {
  margin: 20px 10px 10px 50px;
  width: 90%;
}

.l-form-table.inner-table tr {
  background: transparent;
}

.l-form-table.inner-table td {
  background: transparent;
}

.l-form-table tr {
  cursor: pointer;
}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>
